import InlineSkeleton from '@mindtickle/skeleton/InlineSkeleton';

import { StyledSemanticSearchLoaderWrapper } from './style';

const SemanticSearchLoader = ({ showSearch }: { showSearch: boolean }) => (
  <StyledSemanticSearchLoaderWrapper>
    <InlineSkeleton style={{ height: '32px', width: showSearch ? '320px' : '92px' }} />
  </StyledSemanticSearchLoaderWrapper>
);
export default SemanticSearchLoader;
